import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.trigger = accordions;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if(id[1]){
        const accordionToClick = document.querySelector('#accordion'+id[1]);

        if(accordionToClick){
        if(!accordionToClick.classList.contains('no-parent')){
          const accordionParentToClick = Helper.getParentNodeWithClass(accordionToClick, 'accordion--level-1').querySelector('.js-accordion-toggle');
          if(accordionParentToClick){
            accordionParentToClick.click();
          }
        }
        setTimeout( () => {
            accordionToClick.querySelector('.js-accordion-toggle').click();
            setTimeout(() => {this.scrollTo()}, 500);
          }, 500);
        }
      }
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        const ac_content = el.parentNode.nextElementSibling;
        if(el.classList.contains('active')){
          Helper.slideClose(ac_content);
          el.classList.remove('active');
          ac_content.classList.remove('active');
        } else{
          el.classList.add('active');
          ac_content.classList.add('active');
          Helper.slideOpen(ac_content, true);
        }
      });
    });
  }


  close(el){
    if(el){
      Helper.slideClose(el.nextElementSibling);
      el.classList.remove('active');
    }
  }

  open(el){
    if(el){
      el.classList.add('active');
      Helper.slideOpen(el.nextElementSibling, true);
    }
  }

  scrollTo(){

      let el = null;
      let el_level2 = document.querySelector('.accordion--level-2 '+this.trigger+'.active');

      if(el_level2){
        el = el_level2;
      } else if(el_level1){
        el = el_level1;
      }

      if(el){
        window.scrollTo({
          top: Helper.getOffsetTop(el) - 126 + window.scrollY,
          left: 0,
          behavior: 'smooth'
        });

      }
  }

} export default Accordion;